import React from "react";
import { AppBar, Toolbar, CardMedia } from "@mui/material";
import logo from "../imgs/logo192.png";
import Atras from "./atras";

function Header() {
  const styles = {
    media: {
      marginLeft: "auto",
      marginRight: "auto",
      width: "70px",
      height: "auto",
      marginTop: "3px",
      marginBottom: "3px",
      position: "relative",
      left: -20
    },
  };
  return (
    <AppBar position="fixed">
      <Toolbar>
        <Atras />
        <CardMedia
          component="img"
          image={logo}
          title="Notiline"
          style={styles.media}
        />
      </Toolbar>
    </AppBar>
  );
}

export default Header;
